import React from 'react';
import user from '../Auth/user';
import firebase from '../firebase';
import compose from '../compose';
import { translate } from 'react-i18next';
import {Card, CardText} from 'material-ui/Card';
import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import LoadingIndicator from '../Navigation/LoadingIndicator';
import DatePicker from 'material-ui/DatePicker';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import Receipt from 'material-ui/svg-icons/action/receipt';
import { Link } from 'react-router-dom';
import CsvDownload from './CsvDownload';

class SaleList extends React.Component {
  constructor(props) {
    super(props);
    this.initialState =  {
      sales: [],
      stands: [],
      loadingIndicator: 'flex',
      today: new Date(),
      startDate: Date.now() - 30 * 86400000,
      endDate: Date.now(),
      currentStands:[],
      receiptDialogOpen: false,
      totalValue: 0,
      currentPurchase: ''
    };

    this.state = {
      ...this.initialState
    };
  }
  componentDidMount = () => {
    const {firebase} = this.props;
    const {shopkeeperId} = this.props.user;
    this.standsRef = firebase.database().ref(`shopkeepers/${shopkeeperId}/standsList`);
    this.standsRef.once('value').then((data) => {
      for(var key in data.val()) {
        const stand = {
          key: key,
          name: data.val()[key].name
        };
        const currentStands = this.state.stands.slice();
        currentStands.push(stand);
        this.setState({stands: currentStands});
      }
    });
    this.salesRef = firebase.database().ref(`shopkeepers/${shopkeeperId}/sales`);
    this.retrieveSales();
  }

  retrieveSales = () => {
    const {t} = this.props;
    this.salesOrderedRef = this.salesRef.orderByChild('paidAt').startAt(this.state.startDate).endAt(this.state.endDate);
    const sales = [];
    this.salesOrderedRef.once('value', (snapshot) => {
      var totalValue = 0;
      snapshot.forEach((data) => {
        const sale = {
          key: data.key,
          ...data.val()
        };
        if (this.state.currentStands.length === 0 || this.state.currentStands.indexOf(sale.standId) >= 0) {
          totalValue += Number(sale.price);
          var currentStand = this.state.stands.find((item) => (item.key === sale.standId)) || '';
          if (currentStand) {
            sale.standName = currentStand.name;
          } else {
            sale.standName = t('sale.standDeleted');
          }
          sales.push(sale);
        }
      });
      this.setState({loadingIndicator: 'none', totalValue, sales});
    });
  }

  handleStartDateChange = (event, date) => {
    this.setState({
      startDate: date.getTime(),
      sales: [],
      loadingIndicator: 'flex',
      totalValue: 0
    });
    this.retrieveSales();
  };

  handleEndDateChange = (event, date) => {
    this.setState({
      endDate: date.getTime() + 86399999,
      sales: [],
      loadingIndicator: 'flex',
      totalValue: 0
    });
    this.retrieveSales();
  };

  handleStandChange = (event, index, currentStands) => {
    this.setState({
      currentStands,
      sales: [],
      loadingIndicator: 'flex',
      totalValue: 0});
    this.retrieveSales();
  }

  stands(currentStands) {
    return this.state.stands.map((stand) => (
    <MenuItem value={stand.key} insetChildren={true} key={stand.key} primaryText={stand.name} checked={currentStands && currentStands.indexOf(stand.key) > -1} />
  ));}

  render() {
    //Only children will be rendered
    if (this.props.location.pathname !== '/sales') {
      return null;
    }
    const {t, user} = this.props;
    const sales =
    this.state.sales.map((sale) => (
      <TableRow key={sale.key}>
        <TableRowColumn className='hidden-xs' style={{whiteSpace: 'normal',
          wordWrap: 'break-word'}}>{new Date(sale.paidAt).toLocaleString(user.language, {year: '2-digit', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'})}</TableRowColumn>
        <TableRowColumn className='hidden-lg'>{new Date(sale.paidAt).toLocaleDateString(user.language)}</TableRowColumn>
        <TableRowColumn className='hidden-xs'>{sale.standName}</TableRowColumn>
        <TableRowColumn style={{whiteSpace: 'normal',
          wordWrap: 'break-word'}} >{sale.productName}</TableRowColumn>
        <TableRowColumn style={{textAlign: 'right'}}>{sale.price + ' €'}</TableRowColumn>
        <TableRowColumn  style={{whiteSpace: 'normal',
          wordWrap: 'break-word', textAlign: 'right'}}>
          <IconButton touch={true} containerElement={<Link to={`/sales/${sale.key}`} />}><Receipt /></IconButton>
        </TableRowColumn>
      </TableRow>
    ));

    const footer = this.state.totalValue ? <TableRow>
    <TableRowColumn style={{color: '#9e9e9e'}}>{t('sale.total')}</TableRowColumn>
    <TableRowColumn style={{color: '#9e9e9e'}} className='hidden-xs'></TableRowColumn>
    <TableRowColumn style={{color: '#9e9e9e'}}></TableRowColumn>
    <TableRowColumn style={{color: '#9e9e9e', textAlign: 'right'}} >{this.state.totalValue.toFixed(2) + ' €'}</TableRowColumn>
    <TableRowColumn> </TableRowColumn></TableRow> : <TableRow>
    <TableRowColumn style={{color: '#9e9e9e'}}>{t('sale.noRecords')}</TableRowColumn></TableRow>;
    return (
      <Card className='cardStyle'>
        <Toolbar>
          <ToolbarGroup>
            <ToolbarTitle text={t('sale.sales')} />
          </ToolbarGroup>
        </Toolbar>
        <CardText>
          <SelectField
            floatingLabelText={t('stand.stands')}
            value={this.state.currentStands}
            onChange={this.handleStandChange}
            multiple={true}>
            {this.stands(this.state.currentStands)}
          </SelectField>
          <DatePicker
            floatingLabelText={t('startRange')}
            cancelLabel={t('cancel')}
            locale={user.language}
            maxDate={new Date(this.state.endDate)}
            DateTimeFormat={Intl.DateTimeFormat}
            value={new Date(this.state.startDate)}
            autoOk={true}
            onChange={this.handleStartDateChange}
          />
          <DatePicker
            floatingLabelText={t('endRange')}
            cancelLabel={t('cancel')}
            locale={user.language}
            minDate={new Date(this.state.startDate)}
            maxDate={this.state.today}
            DateTimeFormat={Intl.DateTimeFormat}
            value={new Date(this.state.endDate)}
            autoOk={true}
            onChange={this.handleEndDateChange}/>
          <CsvDownload sales={this.state.sales} />
          <Table style={{tableLayout: 'auto'}} bodyStyle={{overflow:'visible'}}>
            <TableBody displayRowCheckbox={false}>
              <TableRow>
                <TableRowColumn style={{color: '#9e9e9e'}}>{t('date')}</TableRowColumn>
                <TableRowColumn style={{color: '#9e9e9e'}} className='hidden-xs'>{t('stand.stand')}</TableRowColumn>
                <TableRowColumn style={{color: '#9e9e9e'}}>{t('product.product')}</TableRowColumn>
                <TableRowColumn style={{color: '#9e9e9e'}} >{t('price')}</TableRowColumn>
                <TableRowColumn> </TableRowColumn>
              </TableRow>
              {sales}
              {footer}
            </TableBody>
          </Table>
          <LoadingIndicator display={this.state.loadingIndicator} />
        </CardText>
      </Card>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(SaleList);



// WEBPACK FOOTER //
// ./src/Sale/SaleList.js